import { RequestSender } from '@/infrastructure';
import { BaseSuperAgentRequestFactory } from '@studyportals/mb-platform-http-requests';
import { LurchClient } from '@studyportals/sp-lurch-interface';

const lurchurl = webpackDefinitions.VUE_APP_LURCH_URL;
const lurchClient = new LurchClient(new BaseSuperAgentRequestFactory(), RequestSender, lurchurl);

export default lurchClient;
